<template>
  <div class="main-page">
    <Menus title="投诉建议" />
    <div class="container-flex ">
      <div class="wrap">
        <div class="message-title">选择类别</div>
        <div class="choose-type">
          <div
            class="item"
            v-for="(item, index) in suggesType"
            :key="'key-'+index"
            @click="suggest.com_type=item"
          >
            <span :class="{on:item==suggest.com_type,'nomargin':(index+1)%3==0}">{{item}}</span>
          </div>
        </div>
        <div class="message-title">投诉建议</div>
        <div class="textarea">
          <textarea
            placeholder="内容"
            v-model="suggest.content"
          ></textarea>
        </div>
        <div class="message-title">联系方式（必填）</div>
        <div class="message-tip-info">
          请填写您的电话号码，以便工作人员与您取得联系。
        </div>
        <div class="input">
          <input
            type="text"
            placeholder="姓名"
            v-model="suggest.name"
          />
        </div>
        <div class="input ">
          <input
            type="text"
            placeholder="联系电话"
            v-model="suggest.tell"
            maxlength="11"
          />
          <button @click="sendVerifyCode">{{wait==60 ? '获取验证码' : wait+'秒后重试'}}</button>

        </div>
        <div class="input ">
          <input
            type="text"
            placeholder="验证码"
            v-model="suggest.captcha"
            maxlength="6"
          />

        </div>

        <div
          class="content-block"
          @click="updateForm"
        >
          <a
            class="button button-big"
            :class="{'button-fill':suggest.com_type && suggest.content, 'color-gray': !suggest.com_type || !suggest.content}"
          >提交</a>
        </div>
      </div>
    </div>
    <Alert
      v-if="alert.show"
      :info="alert.info"
      :recall="alert.recall"
      @setClose="value=>alert.show=value"
    />
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import Alert from '@/components/Alert'
import { suggesType } from '../datas/js/config.js'
export default {
  components: {
    Menus,
    Alert
  },
  data () {
    return {
      suggesType,
      alert: {
        // 提示内容
        show: false,
        info: '',
        recall: () => { }
      },
      scrollTop: 0,
      suggest: {
        com_type: '',
        content: '',
        tell: '',
        name: '',
        captcha: ''
      },

      wait: 60,
      isMobile: false
    }
  },
  watch: {
    'suggest.tell' (val) {
      val = val.replace(' ', '')
      let checkTell = /^1[3456789]\d{9}$/
      this.isMobile = checkTell.test(val)
    }
  },
  methods: {
    async sendVerifyCode () {
      if (this.wait != 60 && this.isMobile) return
      let checkTell = /^1[3456789]\d{9}$/
      if (!(checkTell.test(this.suggest.tell))) {
        this.alert.show = true
        this.alert.info = '请输入正确的手机号码!'
        return
      }
      const { status, msg } = await this.$post(
        `/api/services/sms/send/${this.suggest.tell}/?web_no_login=c14ad1b1d34ad244`
      )
      if (!status) {
        this.alert.show = true
        this.alert.info = msg
      }
      this.time()
    },
    time () {
      if (this.wait === 0) {
        this.wait = 60
      } else {
        this.wait--
        setTimeout(() => this.time(), 1000)
      }
    },
    async updateForm () {
      if (!this.suggest.com_type) {
        this.alert.show = true
        this.alert.info = '请选择类别!'
        return
      }
      if (!this.suggest.content) {
        this.alert.show = true
        this.alert.info = '请填写投诉建议!'
        return
      }
      if (!this.suggest.name) {
        this.alert.show = true
        this.alert.info = '请填写姓名!'
        return
      }
      let reg = /^[\u4e00-\u9fa5]{1,6}$/
      if (!reg.test(this.suggest.name)) {
        this.alert.show = true
        this.alert.info = '姓名必须为中文，长度在1到6个字符！'
        return
      }
      if (!this.suggest.captcha) {
        this.alert.show = true
        this.alert.info = '请填写验证码!'
        return
      }

      const res = await this.$post('/pufa/complain/add/', {
        com_type: this.suggest.com_type,
        content: this.suggest.content,
        tell: this.suggest.tell,
        name: this.suggest.name,
        code: this.$store.state.device.point.code,
        captcha: this.suggest.captcha
      })
      if (res.status === 1) {
        this.suggest.com_type = ''
        this.suggest.content = ''
        this.suggest.tell = ''
        this.suggest.name = ''
        this.suggest.captcha = ''
        this.alert.show = true
        this.alert.info = '提交成功'
      } else {
        this.suggest.captcha = ''
        this.alert.show = true
        this.alert.info = res.msg || '提交失败！请重新提交'
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.container-flex
  .wrap
    width 12rem
    margin 0 auto
    color #fff
  .message-title
    font-size 0.3rem
    margin-bottom 0.1rem
  .message-tip-info
    font-size 0.22rem
    color red
    padding 0 0 0.15rem 0
  .choose-type
    display flex
    padding 0.1rem 0 0.15rem 0
    flex-wrap wrap
    .item
      width 33.33%
      span
        height 0.5rem
        line-height 0.5rem
        border 1px solid rgba(255, 255, 255, 0.2)
        margin 0 0.1rem 0.1rem 0
        display block
        text-align center
        border-radius 5px
        background rgba(255, 255, 255, 0.2)
        font-size 0.2rem
        &.on
          background #f29530
          border-color #f29530
        &.nomargin
          margin-right 0
  .textarea
    textarea
      width 100%
      height 2.4rem
      margin-bottom 0.3rem
      border-radius 10px
      border 1px solid rgba(255, 255, 255, 0.2)
      background rgba(255, 255, 255, 0.2)
      padding 0.2rem
      font-size 0.2rem
      outline none
  .input
    position relative
    input
      width 100%
      height 0.5rem
      margin-bottom 0.3rem
      border-radius 0.08rem
      border 1px solid rgba(255, 255, 255, 0.2)
      background rgba(255, 255, 255, 0.2)
      padding 0 0.2rem
      font-size 0.2rem
      outline none
    button
      position absolute
      right 0
      top 0
      font-size 0.2rem
      height 0.5rem
      padding 0 0.2rem
      background #f29530
      border-radius 0 0.1rem 0.1rem 0
    .err-info
      position absolute
      left 0
      bottom 0
      color red
      font-size 0.2rem
  .content-block
    background-color #f29530
    margin 0 auto
    cursor pointer
    display block
    font-size 0.28rem
    font-weight 400
    height 0.72rem
    line-height 0.72rem
    text-align center
    width 2.8rem
    border-radius 0.1rem
    -webkit-tap-highlight-color rgba(0, 0, 0, 0)
    a
      color rgb(255, 255, 255)
</style>
